import React from 'react';
import { FairnessCalculator } from '../fairness/FairnessCalculator';

export const OriginalVerifyForm = ({ game, revealed }) => <FairnessCalculator key={game.owner} game={game} revealed={revealed} />;